// Rechte Hälfte: je Meeting eine Verteilungssäule, dazu der gestrichelte
// Erwartungspfad. Die Bins sitzen auf der erwarteten Rate des vorherigen
// Meetings, wandern also mit dem Pfad nach unten — dieselbe Ratenraum-Logik wie
// links, nur mit rollender Basis.

import * as d3 from "d3";

import { PALETTE, binColor, binOpacity } from "../../palette";
import { deltaCompact, localDayShort, pct, tsDate } from "../../format";
import type { G, Model } from "../model";

export function drawForward(g: G, model: Model, lang: string): void {
    const { axisY } = model.layout;
    const { fwd, nF, colW, cellH } = model;

    fwd.meetings.forEach((m, i) => {
        const cells = m.p
            .map((q, j) => ({ q, j }))
            .filter((o) => o.q >= 5)
            .map((o) => ({
                y: model.yFwdCell(i, o.j) - cellH / 2,
                c: binColor(model.deltas[o.j]),
                o: binOpacity(o.q),
            }));

        g.append("g")
            .selectAll("rect")
            .data(cells)
            .join("rect")
            .attr("x", model.xF(i) - colW / 2)
            .attr("y", (c) => c.y)
            .attr("width", colW)
            .attr("height", Math.max(2, cellH))
            .attr("rx", 1)
            .attr("fill", (c) => c.c)
            .attr("opacity", (c) => c.o);
    });

    let path = "M" + model.layout.split + " " + model.yFwdStart;
    for (let i = 0; i < nF; i++) path += "H" + model.xF(i) + "V" + model.yFwdPoint(i);

    g.append("path")
        .attr("d", path)
        .attr("fill", "none")
        .attr("stroke", PALETTE.ink)
        .attr("stroke-width", 2)
        .attr("stroke-dasharray", "6 4")
        .attr("stroke-linecap", "round");

    g.selectAll("circle.fwd")
        .data(d3.range(nF))
        .join("circle")
        .attr("class", "fwd")
        .attr("cx", (i) => model.xF(i))
        .attr("cy", (i) => model.yFwdPoint(i))
        .attr("r", 3.4)
        .attr("fill", PALETTE.ink);

    g.selectAll("text.fwdDate")
        .data(fwd.meetings)
        .join("text")
        .attr("class", "fwdDate")
        .attr("x", (_, i) => model.xF(i))
        .attr("y", axisY + 18)
        .attr("text-anchor", "middle")
        .attr("font-size", 10)
        .attr("fill", PALETTE.inkFaint)
        .text((m) => localDayShort(tsDate(m.decisionTs), lang));

    g.selectAll("text.fwdVal")
        .data(fwd.meetings)
        .join("text")
        .attr("class", "fwdVal")
        .attr("x", (_, i) => model.xF(i))
        .attr("y", axisY + 34)
        .attr("text-anchor", "middle")
        .attr("font-size", 11)
        .attr("fill", PALETTE.inkMuted)
        .text((m) =>
            model.isRate ? pct(m.rateBp, lang, 2) : deltaCompact(m.rateBp - m.baseBp, lang),
        );
}
